// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"_66HFG","rc-tabs-tab-active":"c8BG6","input-suffix":"F2NG3","nav-item":"_3eq4L","tooltip":"_8COr5","right":"sGqxO","left":"uiMag","bottom":"jSOZ1","top":"_4cRUX"};